export const CACHE_KEY_LIST_REGISTERS = 'registers';
export const CACHE_KEY_REGISTERS = 'registers-one';
export const ROUTE_PATH_REGISTERS = '/registers/management';
export const TRANSLATION_PREFIX_REGISTERS = 'registers';

export const REGISTER_PERIOD = {
  DAILY: 'daily',
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
  BIMONTHLY: 'bimonthly',
  QUARTERLY: 'quarterly',
  SEMESTER: 'semester',
  YEARLY: 'yearly',
};

